export enum ELocationPageState {
  address = 0,
  cities = 1
}
